<template lang="pug">
.content.create-user
  Errors(:errors='errors')

  section.wrapper
    ItemSection.personal-details(title="Personal Details" :summary="personalDetailsSummaryText")
      template(#left)
        label.row(label-for='fullname') Full name
        label.row(label-for='emailAddress') Email address
        label.row(label-for='telephoneNumber') Telephone number

      template(#right)
        b-form-input.row.form-control(id='fullname' type='text' v-model='form.fullname' required placeholder='(required)' autofocus)
        b-form-input.row.form-control(id='emailAddress' type='text' v-model='form.emailAddress' required placeholder='(required)')
        b-form-input.row.form-control(id='telephoneNumber' type='text' v-model='form.telephoneNumber')

    ItemSection.agency-details(title="Agency details" :summary="agencyDetailsSummaryText")
      template(#left)
        label.row(label-for='reference') Reference

      template(#right)
        b-form-input.row.form-control(id="reference" type='text' v-model='form.reference')
</template>

<script>
import { VueSlideoutForm } from "@/plugins/vue-form-slideout/VueSlideoutForm";
import { Roles } from "@timesheets/constants-common";
import "./scss";
import { Contacts } from "@timesheets/webapp-support";
import { CreatedEvent } from "@gemma/events";

export default {
  name: Roles.RecruitmentAgencyAdministrationRole.TypeName + "CreateContact",
  extends: VueSlideoutForm,
  data() {
    return {
      form: {
        fullname: null,
        emailAddress: null,
        telephoneNumber: null,
        reference: null,
      },
      notify: {
        success: form => `User ${form.fullname} created`,
        failure: form => `Could not create user ${form.fullname}`,
      },
      submitApiRequest: Contacts.CreateContact.submitApiRequest,
    };
  },
  computed: {
    personalDetailsSummaryText() {
      if (!this.form.fullname) {
        return undefined;
      }

      let text = this.form.fullname;
      if (this.form.emailAddress) {
        text += ` (${this.form.emailAddress})`;
      }

      return text;
    },
    agencyDetailsSummaryText() {
      return this.form.reference;
    },
  },
  methods: {
    clear() {
      this.form.fullname = null;
      this.form.emailAddress = null;
      this.form.telephoneNumber = null;
      this.form.reference = null;
    },
    onSuccess(contact) {
      const createdEvent = new CreatedEvent("contact", contact);
      this.$emit("create", createdEvent);
    },
  },
};
</script>
